import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

const MESSAGES = {
  "401": "Tu sesión expiró. Por favor iniciá sesión nuevamente.",
  "403": "No tenés permisos para acceder a este recurso.",
  "429": "Demasiadas solicitudes al servidor. Por favor esperá unos segundos e intentá de nuevo.",
  render: "Ocurrió un error inesperado en la aplicación.",
  default: "Ocurrió un error inesperado.",
};

export default function ErrorPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reason = params.get("reason") || "default";
  const returnPath = sessionStorage.getItem("errorReturnPath") || "/";

  const handleRetry = () => {
    sessionStorage.removeItem("errorReturnPath");
    navigate(returnPath);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      <Typography variant="h6">
        {MESSAGES[reason] ?? MESSAGES.default}
      </Typography>
      <Button variant="contained" onClick={handleRetry}>
        Reintentar
      </Button>
      <Button variant="text" onClick={() => navigate("/")}>
        Volver al inicio
      </Button>
    </Box>
  );
}
